import queryString from "query-string";
import {
  GET_LIST,
  CREATE_DATA,
  UPDATE_DATA,
  REMOVE_DATA,
} from "../../api/site";

const state = {
  list: [],
  editData: "",
};

const mutations = {
  SET_LIST: (states, payload) => {
    states.list = payload;
  },
  SET_EDIT: (states, payload) => {
    states.editData = payload;
  },
};

const actions = {
  GET_LIST: async ({ commit }, query) => {
    query = queryString.stringify(query);
    const resp = await GET_LIST(query);
    const data = resp.data.data;
    commit("SET_LIST", data);
  },
  CREATE_DATA: ({}, payload) => {
    return CREATE_DATA(payload);
  },
  UPDATE_DATA: ({}, { id, payload }) => {
    return UPDATE_DATA(id, payload);
  },
  REMOVE_DATA: ({}, id) => {
    return REMOVE_DATA(id);
  },
};

const getters = {
  list: (states) => states.list,
  detail: (states) => states.detail,
  editData: (states) => states.editData,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
